const slidersetup = (function () {
  let mainsliderContainer,
    mainsliderContainerMain,
    mainsliderWrapper,
    mainsliderFilterAttributes,
    mainsliderItems,
    mainsliderButtons,
    mainsliderScrollUpButton,
    mainsliderScrollDownButton,
    mainsliderArrowContainer,
    mainsliderCurrentSelectedSlide,
    isMobile = false,
    alreadyInit = false,
    windowsStyles='',
    textContent='',
    windowsEdgeStyles='',
    shadowRoot;


  const precomputedVariations = new Map();


  const delay = (ms) => new Promise(resolve => setCustomTimeout(resolve, ms));
  const isWindows = navigator.userAgent.includes('Windows');
  const isEdge = navigator.userAgent.includes('Edg/');


  const debounce = (func, delay) => {
    let timeoutId;
    return (...args) => {
      if (timeoutId) clearTimeout(timeoutId);
      timeoutId = setCustomTimeout(() => func(...args), delay);
    };
  };


  const hideSpinner = () => {
    const spinnerContainer = document.getElementById('spinner-container-slider');
    console.log('spinner-container-slider', spinnerContainer);
    if (spinnerContainer) {
      spinnerContainer.style.display = 'none'; // Hide spinner
    }

  };

  const eventListeners = [];
  const variations = [
    "lefttdbodynophotoheaderbulletscentersquaresidebar",
    "lefttdbodybluetheme",
    "lefttdbodywhitebluethemenophotoheadercenter",
    "lefttdbodywhitebluethemenophotoheadercentersidebar",
    "lefttdbodynophotoheaderbulletscentersquaresidebar2",
    "lefttdbodythemenophotocenterimages",
    "lefttdbodywhitetheme",
    "lefttdbodywhitethemedark2",
    "lefttdbodywhitethemedark2center",
    "lefttdbodywhitethemenophoto",
    "lefttdbodythemenophotoorange",
    "lefttdbodywhitebluethemenophotoheadercenteronecolumnfang1",
    "lefttdbodywhitebluethemenophotoheadercenteronecolumn",
    "lefttdbodywhitebluethemenophotoheadercenteronecolumnfang2",
    "lefttdbodywhitebluethemenophotoheadercenteronecolumnfang3",
    "lefttdbodythemenophototopbox",
    "lefttdbodygreentheme",
    "lefttdbodywhitebluethemenophoto",
    "lefttdbodywhitebluethemenophotoheaderbulletscenter",
    "lefttdbodywhitebluethemenophotoheaderbullets",
    "lefttdbodywhitebluethemenophotoheaderbulletscentersquare",
    "lefttdbodywhitebluethemenophotoheaderbulletssquare",
    "lefttdbodywhitebluethemenophotoheaderbulletscentersquarebackgroundh3",
    "lefttdbodywhitethememulticolor",
    "lefttdbodywhitebluethemenophotoheadercenteronecolumnfang4",
    "lefttdbodywhitebluethemenophotoheadercenteronecolumnfang5",
    "lefttdbodywhitebluethemenophotoheadercenteronecolumnfang6",
    "lefttdbodywhitebluethemenophotoheadercenteronecolumnfang7",
    "lefttdbodywhitebluethemenophotoheadercenteronecolumnfang8",
  ];

  const variationsForCoverLetter = [
    "lefttdbodywhitebluethemenophotoheadercenteronecolumnfang3",
    "lefttdbodybluetheme",
    "lefttdbodywhitebluethemenophotoheadercenteronecolumnfang1",
    "lefttdbodywhitebluethemenophotoheaderbulletscentersquareCoverLetter",
    "lefttdbodynophotoheaderbulletscentersquaresidebar2",
    "lefttdbodywhitebluethemenophotoheadercentersidebar",
    "lefttdbodythemenophotoorange",
    "lefttdbodythemenophotocenterimages",
    "lefttdbodywhitebluethemenophotoheadercenteronecolumn",
    "lefttdbodynophotoheaderbulletscentersquaresidebar",
    "lefttdbodywhitebluethemenophotoheadercenter",
    "lefttdbodywhitetheme",
    "lefttdbodywhitethemedark2",
    "lefttdbodywhitethemedark2coverletter",
    "lefttdbodywhitethemenophoto",
    "lefttdbodywhitebluethemenophotoheadercenteronecolumnfang2",
    "lefttdbodythemenophototopbox",
    "lefttdbodygreentheme",
    "lefttdbodywhitebluethemenophoto",
    "lefttdbodywhitebluethemenophotoheaderbulletscenter",
    "lefttdbodywhitebluethemenophotoheaderbullets",
    "lefttdbodywhitebluethemenophotoheaderbulletssquare",
    "lefttdbodywhitebluethemenophotoheaderbulletscentersquarebackgroundh3",
    "lefttdbodywhitethememulticolor",
    "lefttdbodywhitebluethemenophotoheadercenteronecolumnfang4",
    "lefttdbodywhitebluethemenophotoheadercenteronecolumnfang5",
    "lefttdbodywhitebluethemenophotoheadercenteronecolumnfang6",
    "lefttdbodywhitebluethemenophotoheadercenteronecolumnfang7",
    "lefttdbodywhitebluethemenophotoheadercenteronecolumnfang8",
  ];


const variationsForFangResume = [
  "lefttdbodywhitebluethemenophotoheadercenteronecolumnfang1",
  "lefttdbodywhitebluethemenophotoheadercenteronecolumnfang2",
  "lefttdbodywhitebluethemenophotoheadercenteronecolumnfang3",
  "lefttdbodywhitebluethemenophotoheadercenteronecolumnfang4",
  "lefttdbodywhitebluethemenophotoheadercenteronecolumnfang5",
  "lefttdbodywhitebluethemenophotoheadercenteronecolumnfang6",
  "lefttdbodywhitebluethemenophotoheadercenteronecolumnfang7",
  "lefttdbodywhitebluethemenophotoheadercenteronecolumnfang8",
  "lefttdbodynophotoheaderbulletscentersquaresidebar",
  "lefttdbodybluetheme",
  "lefttdbodywhitebluethemenophotoheadercenteronecolumn",
  "lefttdbodywhitebluethemenophotoheadercenter",
  "lefttdbodywhitebluethemenophotoheadercentersidebar",
  "lefttdbodynophotoheaderbulletscentersquaresidebar2",
  "lefttdbodythemenophotocenterimages",
  "lefttdbodywhitetheme",
  "lefttdbodywhitethemedark2",
  "lefttdbodywhitethemedark2center",
  "lefttdbodywhitethemenophoto",
  "lefttdbodythemenophotoorange",
  "lefttdbodythemenophototopbox",
  "lefttdbodygreentheme",
  "lefttdbodywhitebluethemenophoto",
  "lefttdbodywhitebluethemenophotoheaderbulletscenter",
  "lefttdbodywhitebluethemenophotoheaderbullets",
  "lefttdbodywhitebluethemenophotoheaderbulletscentersquare",
  "lefttdbodywhitebluethemenophotoheaderbulletssquare",
  "lefttdbodywhitebluethemenophotoheaderbulletscentersquarebackgroundh3",
  "lefttdbodywhitethememulticolor",
];




  // Timeless Sleek Bold Refined Future Spark Chic Focus Power Legacy Achiever Clear Additional suggestions: Innovator Executive Vibrant Dynamic Elegance Sharp Impactful Trendsetter Empowered Double column Perfectionist Elegant modern Fang Polished Contemporary Creative Stylish Single column Compact Classic High Performer Minimal

  //Consulting
  // Executive Fang Healthcare Marketing performingarts Professional Students Technical, Photo, nophoto
  const variationNamesMap = [
    { id: 'lefttdbodybluetheme', name: 'elegant', style1: 'Photo', style2: 'performingarts', style3: 'Executive', style4: 'Marketing', style5: 'Healthcare', style6: 'Consulting' },
    { id: 'lefttdbodywhitebluethemenophotoheadercenter', name: 'double_column', style1: 'nophoto', style2: 'Technical', style3: 'Professional', style4: 'Executive', style5: 'Consulting', style6: '' },
    { id: 'lefttdbodywhitebluethemenophotoheadercentersidebar', name: 'Timeless', style1: 'nophoto', style2: 'Technical', style3: 'Professional', style4: 'Executive', style5: 'Consulting', style6: '' },
    { id: 'lefttdbodythemenophotocenterimages', name: 'vibrant', style1: 'nophoto', style2: 'performingarts', style3: 'Healthcare', style4: 'Marketing', style5: 'Executive', style6: 'Consulting' },
    { id: 'lefttdbodywhitetheme', name: 'modern', style1: 'Photo', style2: 'Marketing', style3: 'Professional', style4: 'Executive', style5: 'Consulting', style6: 'Students' },
    { id: 'lefttdbodywhitethemedark2', name: 'Innovator', style1: 'Photo', style2: 'Marketing', style3: 'Professional', style4: 'Executive', style5: 'Consulting', style6: 'Students' },
    { id: 'lefttdbodywhitethemedark2center', name: 'Perfectionist', style1: 'nophoto', style2: 'Marketing', style3: 'Professional', style4: 'Executive', style5: 'Consulting', style6: 'Students' },
    { id: 'lefttdbodywhitethemedark2coverletter', name: 'Perfectionist', style1: 'nophoto', style2: 'Marketing', style3: 'Professional', style4: 'Executive', style5: 'Consulting', style6: 'Students' },
    { id: 'lefttdbodywhitethemenophoto', name: 'Magnetic', style1: 'nophoto', style2: 'Marketing', style3: 'Professional', style4: 'Executive', style5: 'Consulting', style6: 'Students' },
    { id: 'lefttdbodythemenophotoorange', name: 'stylish', style1: 'nophoto', style2: 'Students', style3: 'performingarts', style4: 'Marketing', style5: '', style6: '' },
    { id: 'lefttdbodywhitebluethemenophotoheadercenteronecolumn', name: 'single_column', style1: 'nophoto', style2: 'Professional', style3: 'Students', style4: 'Executive', style5: 'Technical', style6: 'Healthcare' },
    { id: 'lefttdbodythemenophototopbox', name: 'trendsetter', style1: 'nophoto', style2: 'Healthcare', style3: 'Marketing', style4: 'Professional', style5: 'Consulting', style6: 'Executive' },
    { id: 'lefttdbodygreentheme', name: 'executive', style1: 'Photo', style2: 'Marketing', style3: 'Executive', style4: 'Students', style5: 'Marketing', style6: 'Healthcare' },
    { id: 'lefttdbodywhitebluethemenophoto', name: 'empowered', style1: 'nophoto', style2: 'Professional', style3: 'Students', style4: 'Executive', style5: 'Technical', style6: 'Consulting' },
    { id: 'lefttdbodywhitebluethemenophotoheaderbulletscenter', name: 'creative', style1: 'nophoto', style2: 'Professional', style3: 'Students', style4: 'Executive', style5: 'Executive', style6: 'Healthcare' },
    { id: 'lefttdbodywhitebluethemenophotoheaderbullets', name: 'future', style1: 'nophoto', style2: 'Professional', style3: 'Students', style4: 'Executive', style5: 'Marketing', style6: 'Healthcare' },
    { id: 'lefttdbodywhitebluethemenophotoheaderbulletscentersquare', name: 'Contemporary', style1: 'nophoto', style2: 'Professional', style3: 'Students', style4: 'Executive', style5: 'Executive', style6: 'Healthcare' },
    { id: 'lefttdbodywhitebluethemenophotoheaderbulletscentersquareCoverLetter', name: 'Contemporary', style1: 'nophoto', style2: 'Professional', style3: 'Students', style4: 'Executive', style5: 'Executive', style6: 'Healthcare' },
    { id: 'lefttdbodywhitebluethemenophotoheaderbulletssquare', name: 'Impactful', style1: 'nophoto', style2: 'Professional', style3: 'Students', style4: 'Executive', style5: 'Executive', style6: 'Healthcare' },
    { id: 'lefttdbodywhitebluethemenophotoheaderbulletscentersquarebackgroundh3', name: 'Spark', style1: 'nophoto', style2: 'Professional', style3: 'Students', style4: 'Executive', style5: 'Executive', style6: 'Healthcare' },
    { id: 'lefttdbodynophotoheaderbulletscentersquaresidebar', name: 'Focus', style1: 'nophoto', style2: 'Professional', style3: 'Students', style4: 'Executive', style5: 'Executive', style6: 'Healthcare' },
    { id: 'lefttdbodynophotoheaderbulletscentersquaresidebar2', name: 'Achiever', style1: 'nophoto', style2: 'Professional', style3: 'Students', style4: 'Executive', style5: 'Executive', style6: 'Healthcare' },
    { id: 'lefttdbodywhitethememulticolor', name: 'Bold', style1: 'Photo', style2: 'Marketing', style3: 'Professional', style4: 'Executive', style5: 'Consulting', style6: 'Students' },
    { id: 'lefttdbodywhitebluethemenophotoheadercenteronecolumnfang8', name: 'Fang 8', style1: 'nophoto', style2: 'Professional', style3: 'Students', style4: 'Fang', style5: 'Technical', style6: 'Healthcare' },
    { id: 'lefttdbodywhitebluethemenophotoheadercenteronecolumnfang2', name: 'Fang 2', style1: 'nophoto', style2: 'Professional', style3: 'Students', style4: 'Fang', style5: 'Technical', style6: 'Healthcare' },
    { id: 'lefttdbodywhitebluethemenophotoheadercenteronecolumnfang3', name: 'Fang 3', style1: 'nophoto', style2: 'Professional', style3: 'Students', style4: 'Fang', style5: 'Technical', style6: 'Healthcare' },
    { id: 'lefttdbodywhitebluethemenophotoheadercenteronecolumnfang4', name: 'Fang 4', style1: 'nophoto', style2: 'Professional', style3: 'Students', style4: 'Fang', style5: 'Technical', style6: 'Healthcare' },
    { id: 'lefttdbodywhitebluethemenophotoheadercenteronecolumnfang5', name: 'Fang 5', style1: 'nophoto', style2: 'Professional', style3: 'Students', style4: 'Fang', style5: 'Technical', style6: 'Healthcare' },
    { id: 'lefttdbodywhitebluethemenophotoheadercenteronecolumnfang6', name: 'Fang 6', style1: 'nophoto', style2: 'Professional', style3: 'Students', style4: 'Fang', style5: 'Technical', style6: 'Healthcare' },
    { id: 'lefttdbodywhitebluethemenophotoheadercenteronecolumnfang7', name: 'Fang 7', style1: 'nophoto', style2: 'Professional', style3: 'Students', style4: 'Fang', style5: 'Technical', style6: 'Healthcare' },
    { id: 'lefttdbodywhitebluethemenophotoheadercenteronecolumnfang1', name: 'Fang 1', style1: 'nophoto', style2: 'Professional', style3: 'Students', style4: 'Fang', style5: 'Technical', style6: 'Healthcare' },


  ];


  // Dynamically translate when accessing
  const getTranslatedVariationNames = () =>
    variationNamesMap.map(item => ({
      ...item,
      name: getI18n(item.name),
    }));

  // Distinct value: beige black blue gold green lavender light blue orange pink purple white ​

  const colorsMap = {
    lefttdbodybluetheme: [
      { id: "default", color: "#375a80", colorname: "blue" },
      { id: "newblue", color: "#b2d4ef", colorname: "lightblue" },
      { id: "salmon", color: "#e9b0ac", colorname: "pink" },
      { id: "green", color: "#5D8064", colorname: "green" },
      { id: "golden", color: "#f1ede4", colorname: "beige" },
    ],
    lefttdbodywhitebluethemenophotoheadercenter: [
      { id: "default", color: "white", colorname: "white" },
      { id: "goldenhighlights", color: "#A67C00", colorname: "gold" },
      { id: "linkbluehighlights", color: "#0070E0", colorname: "blue" },
      { id: "greenhighlights", color: "#5D8064", colorname: "green" },
      { id: "purplehighlights", color: "#53598c", colorname: "purple" },
    ],
    lefttdbodywhitebluethemenophotoheadercentersidebar: [
      { id: "default", color: "#0070E0", colorname: "blue" },
      { id: "goldenhighlights", color: "#A67C00", colorname: "gold" },
      { id: "linkwhitehighlights", color: "white", colorname: "white" },
      { id: "greenhighlights", color: "#5D8064", colorname: "green" },
      { id: "purplehighlights", color: "#53598c", colorname: "purple" },
    ],
    lefttdbodythemenophotocenterimages: [
      { id: "default", color: "#A67C00", colorname: "gold" },
      { id: "whitecenterimages", color: "#FFFFFF", colorname: "white" },
      { id: "bluecenterimages", color: "#375a80", colorname: "blue" },
      { id: "greencenterimages", color: "#5D8064", colorname: "green" },
      { id: "blackcenterimages", color: "#000000", colorname: "black" },
    ],
    lefttdbodywhitethemedark2: [
      { id: "default", color: "#666", colorname: "black" },
      { id: "golden2", color: "#A67C00", colorname: "gold" },
      { id: "blue2", color: "#375a80", colorname: "blue" },
      { id: "green2", color: "#5d8064", colorname: "green" },
      { id: "purple2", color: "#7589ff", colorname: "purple" },
    ],
    lefttdbodywhitethemedark2center: [
      { id: "default", color: "black", colorname: "black" },
      { id: "darkgrey2", color: "#666", colorname: "black" },
      { id: "golden2", color: "#A67C00", colorname: "gold" },
      { id: "blue2", color: "#375a80", colorname: "blue" },
      { id: "purple2", color: "#7589ff", colorname: "purple" },
    ],
    lefttdbodywhitethemedark2coverletter: [
      { id: "default", color: "black", colorname: "black" },
      { id: "darkgrey2", color: "#666", colorname: "black" },
      { id: "golden2", color: "#A67C00", colorname: "gold" },
      { id: "blue2", color: "#375a80", colorname: "blue" },
      { id: "purple2", color: "#7589ff", colorname: "purple" },
    ],
    lefttdbodywhitetheme: [
      { id: "default", color: "#b2d4ef", colorname: "blue" },
      { id: "newblackblack", color: "#FFF", colorname: "white" },
      { id: "newsalmonblack", color: "#e9b0ac", colorname: "pink" },
      { id: "grayorange", color: "#f1ede4", colorname: "beige" },
      { id: "lavendar", color: "#e0e5ff", colorname: "lavender" },
    ],
    lefttdbodywhitethemenophoto: [
      { id: "default", color: "#e9b0ac", colorname: "pink" },
      { id: "newblueblue", color: "#b2d4ef", colorname: "blue" },
      { id: "newblackblack", color: "white", colorname: "white" },
      { id: "grayorange", color: "#f1ede4", colorname: "beige" },
      { id: "lavendar", color: "#e0e5ff", colorname: "lavender" },
    ],
    lefttdbodythemenophotoorange: [
      { id: "default", color: "#474e62", colorname: "blue" },
      { id: "orangewithborder", color: "#f5987a", colorname: "orange" },
      { id: "orangewithwhite", color: "white", colorname: "white" },
      { id: "orangebeige", color: "#f1ede4", colorname: "beige" },
      { id: "orangepurple", color: "#7589ff", colorname: "purple" },
    ],
    lefttdbodywhitebluethemenophotoheadercenteronecolumnfang1: [
      { id: "default", color: "white", colorname: "white" },
      { id: "goldenhighlights", color: "#A67C00", colorname: "gold" },
      { id: "linkbluehighlights", color: "#0070E0", colorname: "blue" },
      { id: "greenhighlights", color: "#5D8064", colorname: "green" },
      { id: "purplehighlights", color: "#53598c", colorname: "purple" },
    ],
    lefttdbodywhitebluethemenophotoheadercenteronecolumn: [
      { id: "default", color: "white", colorname: "white" },
      { id: "goldenhighlights", color: "#A67C00", colorname: "gold" },
      { id: "linkbluehighlights", color: "#0070E0", colorname: "blue" },
      { id: "greenhighlights", color: "#5D8064", colorname: "green" },
      { id: "purplehighlights", color: "#53598c", colorname: "purple" },
    ],
    lefttdbodythemenophototopbox: [
      { id: "default", color: "#A67C00", colorname: "gold" },
      { id: "linkbluetopbox", color: "#0070E0", colorname: "blue" },
      { id: "bluetopbox", color: "#375a80", colorname: "blue" },
      { id: "greentopbox", color: "#5D8064", colorname: "green" },
      { id: "blackdarktopbox", color: "#000000", colorname: "black" },
    ],
    lefttdbodygreentheme: [
      { id: "default", color: "#d8e8e2", colorname: "green" },
      { id: "newbluefullline", color: "#b2d4ef", colorname: "lightblue" },
      { id: "goldenfullline", color: "#e2c395", colorname: "gold" },
      { id: "appricota", color: "#fac0cf", colorname: "pink" },
      { id: "purplefullline", color: "#9ca7e5", colorname: "purple" },
    ],
    lefttdbodywhitebluethemenophoto: [
      { id: "default", color: "#A67C00", colorname: "gold" },
      { id: "linkbluehighlights", color: "#0070E0", colorname: "blue" },
      { id: "bluehighlights", color: "#375a80", colorname: "blue" },
      { id: "greenhighlights", color: "#5D8064", colorname: "green" },
      { id: "purplehighlights", color: "#53598c", colorname: "purple" },
    ],
    lefttdbodywhitebluethemenophotoheaderbulletscenter: [
      { id: "default", color: "white", colorname: "white" },
      { id: "bulletswithgolden", color: "#A67C00", colorname: "gold" },
      { id: "bulletswithblue", color: "#375a80", colorname: "blue" },
      { id: "bulletswithgreen", color: "#5D8064", colorname: "green" },
      { id: "bulletswithpurple", color: "#53598c", colorname: "purple" },
    ],
    lefttdbodywhitebluethemenophotoheaderbullets: [
      { id: "default", color: "white", colorname: "white" },
      { id: "bulletswithgolden", color: "#A67C00", colorname: "gold" },
      { id: "bulletswithblue", color: "#375a80", colorname: "blue" },
      { id: "bulletswithgreen", color: "#5D8064", colorname: "green" },
      { id: "bulletswithpurple", color: "#53598c", colorname: "purple" },
    ],
    lefttdbodywhitebluethemenophotoheaderbulletscentersquare: [
      { id: "default", color: "white", colorname: "white" },
      { id: "bulletswithgolden", color: "#A67C00", colorname: "gold" },
      { id: "bulletswithblue", color: "#375a80", colorname: "blue" },
      { id: "bulletswithgreen", color: "#5D8064", colorname: "green" },
      { id: "bulletswithpurple", color: "#53598c", colorname: "purple" },
    ],
    lefttdbodywhitebluethemenophotoheaderbulletscentersquareCoverLetter: [
      { id: "default", color: "white", colorname: "white" },
      { id: "bulletswithgolden", color: "#A67C00", colorname: "gold" },
      { id: "bulletswithblue", color: "#375a80", colorname: "blue" },
      { id: "bulletswithgreen", color: "#5D8064", colorname: "green" },
      { id: "bulletswithpurple", color: "#53598c", colorname: "purple" },
    ],
    lefttdbodywhitebluethemenophotoheaderbulletssquare: [
      { id: "default", color: "#A67C00", colorname: "gold" },
      { id: "bulletswithwhiteparallelline", color: "white", colorname: "white" },
      { id: "bulletswithblueparallelline", color: "#375a80", colorname: "blue" },
      { id: "bulletswithgreenparallelline", color: "#5D8064", colorname: "green" },
      { id: "bulletswithpurpleparallelline", color: "#53598c", colorname: "purple" },
    ],
    lefttdbodywhitebluethemenophotoheaderbulletscentersquarebackgroundh3: [
      { id: "default", color: "white", colorname: "white" },
      { id: "bulletswithgoldenh3background", color: "#A67C00", colorname: "gold" },
      { id: "bulletswithblueh3background", color: "#375a80", colorname: "blue" },
      { id: "bulletswithgreenh3background", color: "#5D8064", colorname: "green" },
      { id: "bulletswithpurpleh3background", color: "#53598c", colorname: "purple" },
    ],
    lefttdbodynophotoheaderbulletscentersquaresidebar: [
      { id: "default", color: "white", colorname: "white" },
      { id: "bulletswithgolden", color: "#A67C00", colorname: "gold" },
      { id: "bulletswithblue", color: "#375a80", colorname: "blue" },
      { id: "bulletswithgreen", color: "#5D8064", colorname: "green" },
      { id: "bulletswithpink", color: "#d93f67", colorname: "pink" },
    ],
    lefttdbodynophotoheaderbulletscentersquaresidebar2: [
      { id: "default", color: "#f1ede4", colorname: "beige" },
      { id: "bulletswithgoldensidebar", color: "#A67C00", colorname: "gold" },
      { id: "bulletswithbluesidebar", color: "#375a80", colorname: "blue" },
      { id: "bulletswithgreensidebar", color: "#5D8064", colorname: "green" },
      { id: "bulletswithpurplesidebar", color: "#53598c", colorname: "purple" },
    ],
    lefttdbodywhitethememulticolor: [
      { id: "default", color: "#0070E0", colorname: "blue" },
      { id: "goldenhighlights", color: "#A67C00", colorname: "gold" },
      { id: "pinkhighlights", color: "#d93f67", colorname: "pink" },
      { id: "greenhighlights", color: "#5D8064", colorname: "green" },
      { id: "purplehighlights", color: "#53598c", colorname: "purple" },
    ],
    lefttdbodywhitebluethemenophotoheadercenteronecolumnfang2: [
      { id: "default", color: "white", colorname: "white" },
      { id: "goldenhighlights", color: "#A67C00", colorname: "gold" },
      { id: "linkbluehighlights", color: "#0070E0", colorname: "blue" },
      { id: "greenhighlights", color: "#5D8064", colorname: "green" },
      { id: "purplehighlights", color: "#53598c", colorname: "purple" },
    ],
    lefttdbodywhitebluethemenophotoheadercenteronecolumnfang3: [
      { id: "default", color: "white", colorname: "white" },
      { id: "goldenhighlights", color: "#A67C00", colorname: "gold" },
      { id: "linkbluehighlights", color: "#0070E0", colorname: "blue" },
      { id: "greenhighlights", color: "#5D8064", colorname: "green" },
      { id: "purplehighlights", color: "#53598c", colorname: "purple" },
    ],
    lefttdbodywhitebluethemenophotoheadercenteronecolumnfang4: [
      { id: "default", color: "white", colorname: "white" },
      { id: "goldenhighlights", color: "#A67C00", colorname: "gold" },
      { id: "linkbluehighlights", color: "#0070E0", colorname: "blue" },
      { id: "greenhighlights", color: "#5D8064", colorname: "green" },
      { id: "purplehighlights", color: "#53598c", colorname: "purple" },
    ],
    lefttdbodywhitebluethemenophotoheadercenteronecolumnfang5: [
      { id: "default", color: "white", colorname: "white" },
      { id: "goldenhighlights", color: "#A67C00", colorname: "gold" },
      { id: "linkbluehighlights", color: "#0070E0", colorname: "blue" },
      { id: "greenhighlights", color: "#5D8064", colorname: "green" },
      { id: "purplehighlights", color: "#53598c", colorname: "purple" },
    ],
    lefttdbodywhitebluethemenophotoheadercenteronecolumnfang6: [
      { id: "default", color: "white", colorname: "white" },
      { id: "goldenhighlights", color: "#A67C00", colorname: "gold" },
      { id: "linkbluehighlights", color: "#0070E0", colorname: "blue" },
      { id: "greenhighlights", color: "#5D8064", colorname: "green" },
      { id: "purplehighlights", color: "#53598c", colorname: "purple" },
    ],
    lefttdbodywhitebluethemenophotoheadercenteronecolumnfang7: [
      { id: "default", color: "white", colorname: "white" },
      { id: "goldenhighlights", color: "#A67C00", colorname: "gold" },
      { id: "linkbluehighlights", color: "#0070E0", colorname: "blue" },
      { id: "greenhighlights", color: "#5D8064", colorname: "green" },
      { id: "purplehighlights", color: "#53598c", colorname: "purple" },
    ],
    lefttdbodywhitebluethemenophotoheadercenteronecolumnfang8: [
      { id: "default", color: "white", colorname: "white" },
      { id: "goldenhighlights", color: "#A67C00", colorname: "gold" },
      { id: "linkbluehighlights", color: "#0070E0", colorname: "blue" },
      { id: "greenhighlights", color: "#5D8064", colorname: "green" },
      { id: "purplehighlights", color: "#53598c", colorname: "purple" },
    ],

  };


  const fonts = [
    { data: "body-xs", label: "XS" },
    { data: "body-small", label: "S" },
    { data: "body-medium", label: "M" },
    { data: "body-large", label: "L" },
    { data: "body-xlarge", label: "XL" },
  ];


  const init = async (filterValue = null, thisEditor, sourceUrl, content) => {
    await delay(200);
    setStyleText();
    if (alreadyInit) {
      console.log("Already Init Returning");
      return;
    }

    alreadyInit = true;

    mainsliderContainerMain = document.getElementById("mainslider-container");
    shadowRoot = mainsliderContainerMain.attachShadow({ mode: "open" });
    mainsliderContainer = document.createElement("div");
    mainsliderContainer.className = "mainslider-container";
    mainsliderContainer.setAttribute("tabindex", "-1");

    // Append styles for the Shadow DOM
    const style = document.createElement("style");
    style.textContent = isWindows
      ? (isEdge ? windowsEdgeStyles + textContent : windowsStyles + textContent)
      : textContent;

    shadowRoot.appendChild(style);

    // Add stylesheets
    const stylesheets = [
      constants.FONT_AWESOME_CSS,
      constants.FONT_AWESOME_STYLE_CSS,
      constants.FONT_AWESOME_STYLE_FREE_CSS,
      constants.GREEN_LEFT_TEMPLATE_CSS
    ];


    stylesheets.forEach((href) => {
      if (!shadowRoot.querySelector(`link[href="${href}"]`)) {
        const link = document.createElement('link');
        link.rel = 'stylesheet';
        link.href = href;
        shadowRoot.prepend(link);
      } else {
        console.warn(`Stylesheet already loaded: ${href}`);
      }
    });

    shadowRoot.appendChild(mainsliderContainer);

    addDragToScroll(mainsliderContainer);

    mainsliderWrapper = document.querySelector(".mainslider-wrapper");
    mainsliderFilterAttributes = document.getElementById("mainslider-filter-attributes");
    mainsliderScrollUpButton = document.getElementById("mainslider-scroll-up-button");
    mainsliderScrollDownButton = document.getElementById("mainslider-scroll-down-button");
    mainsliderArrowContainer = document.getElementById("mainslider-arrow-container");

    // Add listeners
    if (!isMobile) {
      addEventListener(mainsliderScrollUpButton, "click", scrollUp);
      addEventListener(mainsliderScrollDownButton, "click", scrollDown);
    }
    addEventListener(mainsliderFilterAttributes, "change", filterSlides);
    addEventListener(window, "resize", () => {
      adjustHeight();
      adjustWidthBasedOnViewport();
      if (!isMobile) {
        updateArrowVisibility();
      }
    });

    mainsliderContainer.setAttribute("tabindex", "-1");


    const fang =  thisEditor.checkForFang();
    // Load and create dynamic slides
    await createDynamicSlides(thisEditor, sourceUrl, content, shadowRoot, filterValue, mainsliderContainer,fang);

  };

  const doAfterAllSlidesLoaded = async (filterValue, mainsliderContainer, thisEditor, shadowRoot, className, colorName, fontName) => {
    // Clear the precomputed variations and reset the cache
    precomputedVariations.clear();

    // Cache items after slide creation
    mainsliderItems = Array.from(mainsliderContainer.getElementsByClassName("mainslider-item"));

    // Add button event listeners for scrolling
    mainsliderButtons = document.querySelectorAll(".mainslider-button-container button[data-target]");
    mainsliderButtons.forEach(button => {
      addEventListener(button, "click", () =>
        mainsliderScrollToSlide(button.getAttribute("data-target"))
      );
    });

    // Apply filter logic
    applyFilter(filterValue);

    // Initialize layout


    // Make content non-selectable
    makeContentNonSelectable(mainsliderContainer);

    // Add a focusin event listener to detect when focus re-enters the mainsliderContaine


    addEventListener(
      shadowRoot,
      "keydown",
      debounce(async (event) => {
        if (!mainsliderContainer || !mainsliderItems.length) {
          return;
        }

        // Check if the focus is inside mainsliderContainer or its children
        const activeElement = shadowRoot.activeElement;
        if (!mainsliderContainer.contains(activeElement)) {
          return;
        }

        if (event.key === "Tab") {
          // Allow natural tab behavior but ensure active slide updates correctly
          let activeSlideIndex = mainsliderItems.findIndex((slide) =>
            slide.classList.contains("splide_is_active")
          );

          const isShiftTab = event.shiftKey;

          if (isShiftTab) {
            // Move focus to the previous slide if tabbing backwards
            if (activeSlideIndex > 0) {
              const previousSlide = mainsliderItems[activeSlideIndex - 1];
              focusSlide(previousSlide);
            } else {
              // Reset to the last slide when Shift+Tab on the first slide
              const lastSlide = mainsliderItems[mainsliderItems.length - 1];
              focusSlide(lastSlide);
            }
          } else {
            // Move focus to the next slide if tabbing forwards
            if (activeSlideIndex < mainsliderItems.length - 1) {
              const nextSlide = mainsliderItems[activeSlideIndex + 1];
              focusSlide(nextSlide);
            } else {
              // Reset to the first slide when tabbing forward on the last slide
              const firstSlide = mainsliderItems[0];
              focusSlide(firstSlide);
            }
          }

          event.preventDefault(); // Prevent default tab behavior
        } else {
          // Handle other keyboard navigation
          switch (event.key) {
            case "ArrowUp":
            case "PageUp":
              await moveToPreviousSlide();
              break;
            case "ArrowDown":
            case "PageDown":
              await moveToNextSlide();
              break;
            case "ArrowLeft":
              await moveToPreviousSlide();
              break;
            case "ArrowRight":
              await moveToNextSlide();
              break;
            case "Home":
              focusSlide(mainsliderItems[0]);
              break;
            case "End":
              focusSlide(mainsliderItems[mainsliderItems.length - 1]);
              break;
            default:
              return; // Ignore other keys
          }

          event.preventDefault(); // Prevent default scrolling behavior
        }
      }, 10)
    );


    const focusSlide = (slide) => {
      if (!slide) return;

      // Remove active class from all slides
      mainsliderItems.forEach((item) => {
        item.classList.remove("splide_is_active");
      });

      // Set the current slide as active
      mainsliderCurrentSelectedSlide = slide;
      slide.classList.add("splide_is_active");
      slide.focus(); // Move focus to the current slide

      // Update the theme for the editor
      const className = slide.getAttribute("data-slidename");
      const colorName = "default"; // Adjust if slides have a specific color
      thisEditor.updateTheme(className, colorName);

      // Scroll the container to bring the slide into view
      mainsliderContainer.scrollTo({
        top: slide.offsetTop - mainsliderContainer.offsetTop,
        behavior: "auto",
      });

      // Update arrow visibility
      if (!isMobile) {
        updateArrowVisibility();
      }
    };

    if (!isMobile) {
      // Mouse wheel events
      addEventListener(mainsliderContainer, "wheel", debounce(updateArrowVisibility, 20));

      // Initial arrow visibility
      updateArrowVisibility();
    }



    // applyClassesToVariation(className, colorName, fontName);

    // console.log('The value of  alreadyInit is', alreadyInit);
    // console.log('Setting alreadyInit to', true);

  };


  const selectSlide = (slide, variation, colorClass, fontClass) => {
    if (slide) {
      // Add the 'splide_is_active' class to the slide
      slide.classList.add("splide_is_active");


      // Find and apply 'th_active_color' to the color element
      const colorElement = slide.querySelector(
        `.th_square[id="${colorClass}"] a[data="${variation}|${colorClass}"]`
      );
      if (colorElement) {
        colorElement.classList.add("th_active_color");
      } else {
        console.warn(`No color element found for colorId: ${colorClass}`);
      }

      // Find and apply 'th_active_color' to the font element
      const fontElement = slide.querySelector(`a.fonttheme[data="${variation}|${fontClass}"]`);
      if (fontElement) {
        fontElement.classList.add("th_active_color");
      } else {
        console.warn(`No font element found for font: ${fontClass}`);
      }
    }
  }


  const applyClassesToVariation = async (variation, colorId = null, font = null, oldClassName = null, oldColorName = "default", oldFontName = "body-small") => {
    // Clear classes from all slides and elements
    if (!mainsliderItems) return;
    mainsliderItems.forEach(item => {
      // Remove 'splide_is_active' from all slides
      item.classList.remove("splide_is_active");

      // Remove 'th_active_color' from all color elements
      const allColorElements = item.querySelectorAll(".th_square a");
      allColorElements.forEach(el => el.classList.remove("th_active_color"));

      // Remove 'th_active_color' from all font elements
      const allFontElements = item.querySelectorAll("a.fonttheme");
      allFontElements.forEach(el => el.classList.remove("th_active_color"));
    });

    // Find the slide with the given variation
    const slide = mainsliderItems.find(
      item => item.getAttribute("data-slidename") === variation
    );

    if (slide) {
      // Add the 'splide_is_active' class to the slide
      slide.classList.add("splide_is_active");

      const mainContentBodyDiv = slide.querySelector("#maincontent-body");

      const colorClass = colorId || (oldColorName ? oldColorName : "default");
      const fontClass = font || (oldFontName ? oldFontName : "body-small");

      if (mainContentBodyDiv) {
        // Remove all existing classes from mainContentBodyDiv
        mainContentBodyDiv.className = "";

        // Add the new classes dynamically if oldClassName is not null

        mainContentBodyDiv.classList.add(
          "theme-base",
          "body-builderjs-layout",
          "sliderstyle-only",
          variation,
          colorClass,
          fontClass
        );
      }

      // Find and apply 'th_active_color' to the color element
      const colorElement = slide.querySelector(
        `.th_square[id="${colorClass}"] a[data="${variation}|${colorClass}"]`
      );
      if (colorElement) {
        colorElement.classList.add("th_active_color");
      } else {
        console.warn(`No color element found for colorId: ${colorClass}`);
      }

      // Find and apply 'th_active_color' to the font element
      const fontElement = slide.querySelector(`a.fonttheme[data="${variation}|${fontClass}"]`);
      if (fontElement) {
        fontElement.classList.add("th_active_color");
      } else {
        console.warn(`No font element found for font: ${fontClass}`);
      }
    } else {
      console.warn(`No slide found for variation: ${variation} with timeout of ${timeout}`);
    }

  };




  const unload = () => {
    windowsStyles='';
    textContent='',
    windowsEdgeStyles='';
    alreadyInit = false;
    // Remove all registered event listeners
    eventListeners.forEach(({ element, type, listener }) => {
      if (element) element.removeEventListener(type, listener);
    });
    eventListeners.length = 0; // Clear the event listeners array

    if (shadowRoot) {
      // Remove all children from shadowRoot
      while (shadowRoot.firstChild) {
        shadowRoot.removeChild(shadowRoot.firstChild);
      }

      // Optionally remove event listeners from elements inside shadowRoot
      const shadowElements = shadowRoot.querySelectorAll("*");
      shadowElements.forEach(el => {
        el.replaceWith(el.cloneNode(true)); // Removes event listeners
      });

      shadowRoot = null; // Remove the reference for garbage collection
    }

    // Null check for container before removing children and styles
    const container = document.getElementById("image-carousel-div");
    if (container) {
      removeAllChildrenAndStyles(container);
    }

    mainsliderContainer = null;
    mainsliderContainerMain = null;
    mainsliderWrapper = null;
    mainsliderFilterAttributes = null;
    mainsliderItems = null;
    mainsliderButtons = null;
    mainsliderScrollUpButton = null;
    mainsliderScrollDownButton = null;
    mainsliderArrowContainer = null;
    mainsliderCurrentSelectedSlide = null;
    isMobile = false,
      alreadyInit = false;
  };


  const addEventListener = (element, type, listener) => {
    if (element) {
      const options = { passive: type === 'wheel' || type === 'touchstart' || type === 'touchmove' }; // Add passive flag only for scroll-blocking events
      element.addEventListener(type, listener, options);
      eventListeners.push({ element, type, listener });
    }
  };

  const createDynamicSlides = async (thisEditor, sourceUrl, content, shadowRoot, filterValue, mainsliderContainer, fang=false) => {
    try {
      let originalContent = '';
      if (!content) {
        const html = await fetchContent(sourceUrl);
        originalContent = extractBodyContent(html);
      } else {
        originalContent = content.body ? content.body.innerHTML : content;
      }

      // Clear unused variables
      content = null;

      // Prepare the main content once
      const preparedContent = prepareMainContentBody(originalContent, shadowRoot);
      originalContent = null;

      // Check if URL contains "coverletter" and decide the order
      const isCoverLetter = window.location.href.includes("coverletter");

      let orderedVariations = isCoverLetter ? variationsForCoverLetter : fang ? variationsForFangResume : variations;

      // Calculate the batch size dynamically
      const slideWidth = 100;
      const screenWidth = window.innerWidth;
      const batchSize = Math.max(6, Math.floor(screenWidth / slideWidth));

      adjustHeight();
      adjustWidthBasedOnViewport();

      const target = $("#builder_iframe").contents().find('#maincontent-body-html')[0];
      const data = target.getAttribute('data').split("|");
      const className = data[0];
      const colorName = data[1];
      const fontName = data[2];

      if (className)
        orderedVariations = reorderVariations(orderedVariations, className);



      let startIndex = 0;
      let isFirstSlideCreated = false;

      // Function to load a batch of slides
      const loadBatch = () => {
        const batch = orderedVariations.slice(startIndex, startIndex + batchSize);

        batch.forEach(variation => {
          const variationDetails = variationNamesMap.find(item => item.id === variation);
          const photo = variationDetails && variationDetails.style1.toLowerCase() === "photo";
          const updatedContent = updateMainContentBody(preparedContent, variation, photo);
          const variationColors = colorsMap[variation] || []; // Get colors specific to this variation
          const slide = createSlide(updatedContent, variation, variationColors, fonts, thisEditor);
          if (!isFirstSlideCreated) {
            selectSlide(slide, className, colorName, fontName);
            isFirstSlideCreated = true; // Set the flag to true after the first slide
          }
        });

        // Update the startIndex for the next batch
        startIndex += batchSize;

        if (startIndex < orderedVariations.length) {
          // Schedule the next batch to load
          if ('requestIdleCallback' in window) {
            console.log('requestIdleCallback');
            requestIdleCallback(loadBatch);
          } else {
            setCustomTimeout(loadBatch, 100); // Fallback for browsers without requestIdleCallback
          }
        } else {
          // All slides have been loaded
          orderedVariations = [];
          orderedVariations = null;
          doAfterAllSlidesLoaded(filterValue, mainsliderContainer, thisEditor, shadowRoot, className, colorName, fontName);
        }
      };

      // Start loading the first batch
      loadBatch();
    } catch (error) {
      console.error("Error creating slides:", error);
    }
  };


  const reorderVariations = (variations, className) => {
    // Filter the variations to exclude the className
    const filteredVariations = variations.filter(variation => variation !== className);

    // Return the reordered array with the className at the top
    return className ? [className, ...filteredVariations] : filteredVariations;
  };




  const fetchContent = async (url) => {
    // Add a delay of 10 seconds
    await new Promise(resolve => setCustomTimeout(resolve, 0));

    const response = await fetch(url);
    if (!response.ok) {
      throw new Error(`Failed to fetch content: ${response.status}`);
    }
    return await response.text();
  };

  const addDragToScroll = (container) => {
    let isDragging = false;
    let startY;
    let scrollTop;

    const onMouseDown = (e) => {
      isDragging = true;
      startY = e.pageY - container.offsetTop;
      scrollTop = container.scrollTop;
      e.preventDefault(); // Prevent text selection
    };

    const onMouseMove = (e) => {
      if (!isDragging) return;
      const y = e.pageY - container.offsetTop;
      const walk = (y - startY) * 2; // Adjust multiplier for scroll speed
      container.scrollTop = scrollTop - walk;
    };

    const onMouseUpOrLeave = () => {
      isDragging = false;
      container.classList.remove('dragging'); // Optional for styling
    };

    // Use addEventListener to track and add listeners
    addEventListener(container, 'mousedown', onMouseDown);
    addEventListener(container, 'mousemove', onMouseMove);
    addEventListener(container, 'mouseup', onMouseUpOrLeave);
    addEventListener(container, 'mouseleave', onMouseUpOrLeave);
  };



  const prepareMainContentBody = (originalContent, shadowRoot) => {
    const tempDiv = document.createElement("div");
    tempDiv.innerHTML = originalContent;

    // Create <link> elements for stylesheets

    // Add <link> for Google Fonts preconnect
    // const preconnectLink = document.createElement('link');
    // preconnectLink.rel = 'preconnect';
    // preconnectLink.href = 'https://fonts.googleapis.com';
    // tempDiv.prepend(preconnectLink);

    // // Add <link> for Google Fonts styles
    // const googleFontsLink = document.createElement('link');
    // googleFontsLink.rel = 'stylesheet';
    // googleFontsLink.href = 'https://fonts.googleapis.com/css2?family=Lato:wght@700&family=Open+Sans:wght@400;700&family=Oswald&family=Raleway&family=Roboto:wght@400;700&family=Rubik&display=swap';
    // tempDiv.prepend(googleFontsLink);

    // Add the required styles before accessing mainContentBodyDiv
    const paddingStyle = document.createElement("style");
    paddingStyle.id = "padding-style";

    if (window.location.href.includes("coverletter")) {
      paddingStyle.textContent = `
          .main-table-class {
              --leftdivpadding: 0px 25px 0px 25px;
              --righttdpadding: 0px 25px 0px 20px;
              --righttoppadding: calc(20px + var(--rightoffset)) 25px var(--bottomtoppadding) 20px;
              --image-padding-top: 9px;
              --min-div-height:1300px;
          }
      `;
    } else {
      paddingStyle.textContent = `
          .main-table-class {
              --leftdivpadding: 0px 25px 0px 25px;
              --righttdpadding: 0px 25px 0px 20px;
              --righttoppadding: calc(10px + var(--rightoffset)) 25px var(--bottomtoppadding) 20px;
              --image-padding-top: 9px;
              --min-div-height:1300px;
          }
      `;
    }


    const profileImageStyle = document.createElement("style");
    profileImageStyle.textContent = `
        .profileimage-class {
            border-radius: 50%;
            caret-color: transparent;
            width: 100%;
             height: 100%;
            object-fit: cover;
        }
    `;

    tempDiv.prepend(profileImageStyle);
    tempDiv.prepend(paddingStyle);

    const mainContentBodyDiv = tempDiv.querySelector("#maincontent-body");
    if (mainContentBodyDiv) {
      // Clear existing classes
      mainContentBodyDiv.className = "";
      mainContentBodyDiv.style.textAlign = "left";


      const pageElement = mainContentBodyDiv.querySelector("#PageElement");
      if (pageElement) {
        pageElement.style.visibility = "visible";
        pageElement.setAttribute("aria-hidden", "false");
      }

      // Find and update specific <td> elements
      const tdElementsCoverLetter = mainContentBodyDiv.querySelectorAll(
        'td[class="nopaddingtd coverletterpaddingtd"][style="padding: 0px 0px 0px 0px;"]'
      );
      tdElementsCoverLetter.forEach(td => {
        // Replace the style attribute
        td.setAttribute(
          "style",
          "padding: 0px 0px 0px 0px; text-align:left"
        );
      });

      const tdElements = mainContentBodyDiv.querySelectorAll(
        'td[class="nopaddingtd"][style="padding: 0px 0px 0px 0px;"]'
      );
      tdElements.forEach(td => {
        // Replace the style attribute
        td.setAttribute(
          "style",
          "padding: 0px 0px 0px 0px; text-align:left"
        );
      });

      const divElements = mainContentBodyDiv.querySelectorAll(
        'div[style="display: var(--displayrighttdendemptyspace);"][class="emptyspace-bottom"]'
      );

      if (divElements && divElements.length >= 2) {
        // Convert NodeList to an array and remove the first two elements
        Array.from(divElements).slice(0, 2).forEach(div => div.remove());
      }

      const mainTable = mainContentBodyDiv.querySelector(
        'table#main-table.main-table-class'
      );

      // Check if the table exists and has the class 'main-table-dark'
      if (mainTable && mainTable.classList.contains('main-table-dark')) {
        mainTable.classList.remove('main-table-dark');
      }


      // Query for the 'signature-container' div
      const signatureContainer = mainContentBodyDiv.querySelector('.signature-container');

      // Remove the signature-container div if it exists
      if (signatureContainer) {
        signatureContainer.remove();
      }

      // Find elements with contenteditable="true" and set it to "false"
      const contentEditableElements = mainContentBodyDiv.querySelectorAll('[contenteditable="true"]');
      contentEditableElements.forEach(el => {
        el.setAttribute("contenteditable", "false");
      });

      // Remove all tabindex attributes
      const tabIndexElements = mainContentBodyDiv.querySelectorAll('[tabindex]');
      tabIndexElements.forEach(el => el.removeAttribute('tabindex'));

      // Find all inputs with class "tick-slider-input" and set tabindex="-1"
      const tickSliderInputs = mainContentBodyDiv.querySelectorAll('input.tick-slider-input');
      tickSliderInputs.forEach(input => {
        input.setAttribute('tabindex', '-1');
      });

      updateForLanguage(mainContentBodyDiv);

      const profileImage = mainContentBodyDiv.querySelector("img.profileimage-class");
      const profileImageDiv = mainContentBodyDiv.querySelector("div.profileimagediv-class.image-cropper");

      if (profileImage && profileImageDiv) {
        // Extract the base64 image from the img src attribute
        const base64Image = profileImage.src;

        const existingStyle = Array.from(shadowRoot.querySelectorAll("style")).find(style =>
          style.textContent.includes(".profile-background-image")
        );

        if (!existingStyle) {
          // Create a new style element for the Shadow DOM
          const style = document.createElement("style");

          // Define the .profile-background-image class dynamically
          style.textContent = `
              .profile-background-image {
                  background-image: url('${base64Image}');
                  background-size: cover;
                  background-position: center;
                  background-repeat: no-repeat;
                  caret-color: transparent;
                  width: 140px;
                  height: 140px;
                  position: relative;
                  overflow: hidden;
                  border-radius: 50%;
                  cursor: pointer;
              }
          `;

          // Append the style element to the Shadow DOM
          shadowRoot.appendChild(style);
        } else {
          console.log("Style already exists. Skipping duplication.");
        }

        // Remove the original <img> tag
        profileImage.remove();

        // Update the existing div to apply the updated styles
        profileImageDiv.classList.add("profile-background-image");
      }


    }

    return tempDiv;
  };

  const updateMainContentBody = (preparedContent, variation, photo) => {
    // Create a unique key for the variation and photo combination
    const cacheKey = `${variation}|${photo}`;

    // Check if the result is already cached
    if (precomputedVariations.has(cacheKey)) {
      return precomputedVariations.get(cacheKey);
    }

    // Compute the variation content if not cached
    const tempDiv = document.createElement("div");
    tempDiv.innerHTML = preparedContent.innerHTML; // Use innerHTML to avoid deep cloning

    const mainContentBodyDiv = tempDiv.querySelector("#maincontent-body");
    if (mainContentBodyDiv) {
      // Add required classes dynamically
      mainContentBodyDiv.classList.add(
        "theme-base",
        "body-builderjs-layout",
        "sliderstyle-only",
        variation,
        "default",
        "body-small"
      );

      if (!photo) {
        const profileImageDiv = mainContentBodyDiv.querySelector("div.profileimagediv-class.image-cropper");
        if (profileImageDiv) {
          profileImageDiv.classList.remove("profile-background-image");
        }
      }

      mainContentBodyDiv.setAttribute("data", `${variation}|default|body-small`);
    }

    // Get the updated content as HTML
    const updatedHTML = tempDiv.innerHTML;

    // Cache the computed result
    precomputedVariations.set(cacheKey, updatedHTML);

    return updatedHTML;
  };





  const updateForLanguage = async container => {
    const elements = {
      skills: container.querySelector('#skills'),
      strengths: container.querySelector('#strengths'),
      my_career: container.querySelector('#my_career'),
      summary: container.querySelector('#summary'),
      experience: container.querySelector('#experience'),
      education: container.querySelector('#education'),
      technical_skills: container.querySelector('#technical_skills'),
      languages: container.querySelector('#languages'),
      projects: container.querySelector('#projects'),
      portfolio: container.querySelector('#portfolio'),
      certifications: container.querySelector('#certifications'),
      references: container.querySelector('#references'),
      professional_affiliations: container.querySelector('#professional_affiliations'),
      leadership_awards: container.querySelector('#leadership_awards')
    };

    const updateIfEmptyElements = {
      resume_name: container.querySelector('#resume_name'),
      resume_title: container.querySelector('#resume_title'),
      resume_phone: container.querySelector('#resume_phone'),
      resume_email: container.querySelector('#resume_email'),
      resume_linkedin: container.querySelector('#resume_linkedin'),
      resume_addr: container.querySelector('#resume_addr')
    };

    // Update logic for existing fields (always update)
    Object.entries(elements).forEach(([key, element]) => {
      if (element) {
        element.textContent = getI18n(key);
      }
    });

    // Update logic for new fields (only update if the element is empty and exists)
    Object.entries(updateIfEmptyElements).forEach(([key, element]) => {
      if (element && element.textContent.trim() === "") {
        element.textContent = getI18n(key);
      }
    });
  };






  const extractBodyContent = (html) => {
    try {
      const parser = new DOMParser();
      const doc = parser.parseFromString(html, 'text/html');

      // Extract the body content
      return doc.body ? doc.body.innerHTML : "<div>No content found</div>";
    } catch (error) {
      console.error("Error parsing HTML:", error);
      return "<div>Error parsing content</div>";
    }
  };


  const createSlide = (content, variation, colors, fonts, thisEditor) => {
    // Create the main slide container
    let coverletter = false;
    if (window.location.href.includes("coverletter")) coverletter = true;
    const slide = document.createElement("div");
    if (coverletter) {
      slide.className = "mainslider-item coverletter-item th_container";
    } else {
      slide.className = "mainslider-item th_container";
    }
    slide.setAttribute("data-name", variation);
    slide.setAttribute("data-slidename", variation);
    slide.setAttribute("tabindex", "0");
    slide.style.willChange = "contents";
    slide.contentEditable = "false";
    slide.style.animation = "none";

    // Create the top container div
    const topDiv = document.createElement("div");
    topDiv.className = "slide-topdiv";

    // Create the main thumbnail anchor
    const mainAnchor = document.createElement("a");
    mainAnchor.className = "bodytheme splide_a main_th";
    mainAnchor.setAttribute("data", `${variation}|default`);
    mainAnchor.setAttribute("role", "button");

    const contentDiv = document.createElement("div");
    contentDiv.className = "content";
    contentDiv.innerHTML = content;

    mainAnchor.appendChild(contentDiv);
    topDiv.appendChild(mainAnchor); // Enclose mainAnchor inside topDiv
    slide.appendChild(topDiv); // Add topDiv to the slide

    const bottomOfSlide = document.createElement("div");
    bottomOfSlide.className = "bottom-of-slide";

    // Create the font size options container
    const fontContainer = document.createElement("div");
    if (coverletter) {
      fontContainer.className = "th_square-container-font th_square-container2row coverletter-item ";
    } else {
      fontContainer.className = "th_square-container-font th_square-container2row ";
    }

    fonts.forEach(font => {
      const fontSquare = document.createElement("div");
      fontSquare.className = "th_square";
      fontSquare.style.backgroundColor = "var(--thumbnail-font-color)";

      const fontAnchor = document.createElement("a");
      fontAnchor.className = "fonttheme splide_a color_th font-button";
      fontAnchor.setAttribute("data", `${variation}|${font.data}`);
      fontAnchor.setAttribute("role", "button");
      fontAnchor.innerText = font.label;

      fontSquare.appendChild(fontAnchor);
      fontContainer.appendChild(fontSquare);

      // Add click event listener for fontAnchor
      addEventListener(fontAnchor, "click", function (event) {
        event.stopPropagation(); // Prevent triggering slide click event
        console.log(`Font clicked: ${fontAnchor.getAttribute("data")}`);
        const data = fontAnchor.getAttribute("data").split("|");
        const className = data[0];
        const fontName = data[1];
        thisEditor.unselect();
        thisEditor.hideControls();
        thisEditor.updateTheme(className, null, fontName);
      });
    });

    bottomOfSlide.appendChild(fontContainer);

    // Create the color options container
    const colorContainer = document.createElement("div");
    if (coverletter) {
      colorContainer.className = "th_square-container th_square-container2row coverletter-item ";
    } else {
      colorContainer.className = "th_square-container th_square-container2row";
    }

    colors.forEach(color => {
      const colorSquare = document.createElement("div");
      colorSquare.className = "th_square color-tn"; // Added dummy class
      colorSquare.style.backgroundColor = color.color;
      colorSquare.id = color.id;

      const colorAnchor = document.createElement("a");
      colorAnchor.className = "bodytheme splide_a color_th";
      colorAnchor.setAttribute("data", `${variation}|${color.id}`);
      colorAnchor.setAttribute("data-colorname", color.colorname.toLowerCase()); // Added data-colorname
      colorAnchor.setAttribute("role", "button");

      colorSquare.appendChild(colorAnchor);
      colorContainer.appendChild(colorSquare);

      // Add click event listener for colorSquare
      addEventListener(colorAnchor, "click", function (event) {
        event.stopPropagation(); // Prevent triggering slide click event
        const data = colorAnchor.getAttribute("data").split("|");
        const className = data[0];
        const colorName = data[1];
        thisEditor.unselect();
        thisEditor.hideControls();
        thisEditor.updateTheme(className, colorName);
      });
    });

    bottomOfSlide.appendChild(colorContainer);
    slide.appendChild(bottomOfSlide);

    // Add a middle-aligned text at the end of the slide
    const middleText = document.createElement("div");
    middleText.className = "middle-text";
    const variationInfo = variationNamesMap.find(item => item.id === variation);
    middleText.innerText = variationInfo ? getI18n(variationInfo.name) : 'Unnamed Variation';
    slide.appendChild(middleText);

    // Add click event listener for the main slide
    addEventListener(slide, "click", function (event) {
      // Ensure the event target is not a child of color or font container
      const target = event.target;
      if (
        target.closest(".color_th") ||
        target.closest(".font-button")
      ) {
        return; // Do nothing if the click originated from a child element
      }

      const className = variation;
      const colorName = "default";
      thisEditor.unselect();
      thisEditor.hideControls();
      if (typeof window.externalCleanupDragState === "function") { //to remove move drag drop highlights
        window.externalCleanupDragState();
      }
      thisEditor.updateTheme(className, colorName);
    });



    mainsliderContainer.appendChild(slide);
    coverletter = null;
    return slide;
  };



  const adjustHeight = async () => {
    if (!mainsliderWrapper) return;

    const viewportHeight = window.innerHeight;
    const wrapperTop = mainsliderWrapper.getBoundingClientRect().top;
    mainsliderWrapper.style.height = `${viewportHeight - wrapperTop - 26}px`;

  };

  const adjustWidthBasedOnViewport = () => {
    const viewportWidth = window.innerWidth;
    if (viewportWidth < 1260) {
      isMobile = true;
      updateLayout("calc(100vw)", "360px", true);
    } else if (viewportWidth < 1600) {
      updateLayout("216px", "calc(100vw - 40px)");
    } else {

      updateLayout("440px", "calc(100vw - 40px)");
    }
  };

  const updateLayout = (width, height, isMobile = false) => {
    if (!mainsliderContainer || !mainsliderArrowContainer) return;


    mainsliderContainerMain.style.width = width;
    mainsliderContainerMain.style.height = height;
    mainsliderContainerMain.classList.toggle("mobile", isMobile);
    mainsliderContainerMain.style.overflowY = isMobile ? "hidden" : "auto";
    mainsliderContainerMain.style.overflowX = isMobile ? "auto" : "hidden";

    mainsliderContainer.style.width = `calc(${width} - 20px)`;
    mainsliderContainer.style.height = height;
    mainsliderContainer.classList.toggle("mobile", isMobile);
    mainsliderContainer.style.overflowY = isMobile ? "hidden" : "auto";
    mainsliderContainer.style.overflowX = isMobile ? "auto" : "hidden";
    mainsliderArrowContainer.style.display = isMobile ? "none" : "flex";
    adjustHeight();
    if (!isMobile) updateArrowVisibility();
  };

  const filterSlides = () => {
    if (!mainsliderFilterAttributes || mainsliderItems.length === 0) return;

    updateHistoryAndReplaceState('slidesfilter', mainsliderFilterAttributes.value);

    const selectedAttribute = mainsliderFilterAttributes.value || "all";

    mainsliderItems.forEach((item) => {
      const slideVariation = item.dataset.slidename;

      const variationInfo = variationNamesMap.find((v) => v.id === slideVariation);
      const colors = colorsMap[slideVariation] || [];

      const matchesStyle =
        selectedAttribute === "all" ||
        (variationInfo &&
          Object.keys(variationInfo).some(
            (key) =>
              key.startsWith("style") &&
              variationInfo[key]?.toLowerCase() === selectedAttribute
          ));

      const matchesColor =
        selectedAttribute === "all" ||
        colors.some((color) => color.colorname.toLowerCase() === selectedAttribute);

      // Show or hide the slide based on the matching styles or colors
      item.style.display = matchesStyle || matchesColor ? "flex" : "none";

      // Show all `th_square` color options if style is selected
      const colorSquares = item.querySelectorAll(".th_square.color-tn");
      colorSquares.forEach((square) => {
        const colorMatch =
          selectedAttribute === "all" ||
          colors.some(
            (color) =>
              color.colorname.toLowerCase() === selectedAttribute &&
              square.id === color.id
          );

        // Display only matching color thumbnails for the selected color
        square.style.display = matchesColor ? (colorMatch ? "block" : "none") : "block";
      });
    });
  };



  const applyFilter = filterValue => {
    if (!mainsliderFilterAttributes || mainsliderItems.length === 0) {

      return;
    }

    if (filterValue) {
      mainsliderFilterAttributes.value = filterValue;
    } else {
      mainsliderFilterAttributes.selectedIndex = 0;
    }

    filterSlides();
  };

  const mainsliderScrollToSlide = async (targetName) => {
    if (!mainsliderItems || mainsliderItems.length === 0 || !mainsliderContainer) {
      return;
    }
    const targetSlide = mainsliderItems.find(item => {
      const slideName = item.getAttribute("data-slidename");
      return slideName === targetName;
    });

    if (targetSlide) {
      mainsliderContainer.scrollTo({
        top: targetSlide.offsetTop - mainsliderContainer.offsetTop,
        left: targetSlide.offsetLeft - mainsliderContainer.offsetLeft,
        behavior: "auto",
      });
      mainsliderCurrentSelectedSlide = targetSlide;

      if (!isMobile) updateArrowVisibility();
    }

  };


  const updateArrowVisibility = async () => {
    if (!mainsliderContainer || !mainsliderScrollUpButton || !mainsliderScrollDownButton) return;

    const { scrollTop, scrollHeight, clientHeight } = mainsliderContainer;
    mainsliderScrollUpButton.disabled = scrollTop === 0;
    mainsliderScrollDownButton.disabled = scrollTop + clientHeight >= scrollHeight;
  };

  const scrollUp = async () => {
    if (!mainsliderContainer) return;
    mainsliderContainer.scrollBy({ top: -353, behavior: "smooth" });
    await delay(20);
    updateArrowVisibility();
  };

  const scrollDown = async () => {
    if (!mainsliderContainer) return;
    mainsliderContainer.scrollBy({ top: 353, behavior: "smooth" });
    await delay(20);
    updateArrowVisibility();
  };
  const makeContentNonSelectable = element => {
    if (element) {
      element.style.userSelect = "none";
      element.style.webkitUserSelect = "none";
      element.style.msUserSelect = "none";
      element.style.MozUserSelect = "none";
    }
  };


  const moveToNextSlide = async () => {
    if (!mainsliderItems || mainsliderItems.length === 0 || !mainsliderCurrentSelectedSlide) return;

    const currentIndex = mainsliderItems.indexOf(mainsliderCurrentSelectedSlide);
    const nextIndex = (currentIndex + 1) % mainsliderItems.length; // Loop back to the first slide
    const nextSlide = mainsliderItems[nextIndex];

    const className = nextSlide.getAttribute("data-slidename");
    const colorName = "default"; // Adjust as needed for specific slide color selection

    // Remove 'splide_is_active' from all slides
    mainsliderItems.forEach(item => {
      item.classList.remove("splide_is_active");
    });

    mainsliderCurrentSelectedSlide = nextSlide;
    nextSlide.classList.add("splide_is_active");

    mainsliderContainer.scrollTo({
      top: nextSlide.offsetTop - mainsliderContainer.offsetTop,
      behavior: "smooth",
    });

    // Update the theme via the editor
    thisEditor.updateTheme(className, colorName);

    if (!isMobile) {
      await delay(50); // Small delay for smooth scrolling
      updateArrowVisibility();
    }
  };

  const moveToPreviousSlide = async () => {
    if (!mainsliderItems || mainsliderItems.length === 0 || !mainsliderCurrentSelectedSlide) return;

    const currentIndex = mainsliderItems.indexOf(mainsliderCurrentSelectedSlide);
    const prevIndex = (currentIndex - 1 + mainsliderItems.length) % mainsliderItems.length; // Loop to the last slide
    const prevSlide = mainsliderItems[prevIndex];

    const className = prevSlide.getAttribute("data-slidename");
    const colorName = "default"; // Adjust as needed for specific slide color selection

    // Remove 'splide_is_active' from all slides
    mainsliderItems.forEach(item => {
      item.classList.remove("splide_is_active");
    });

    mainsliderCurrentSelectedSlide = prevSlide;
    prevSlide.classList.add("splide_is_active");

    mainsliderContainer.scrollTo({
      top: prevSlide.offsetTop - mainsliderContainer.offsetTop,
      behavior: "smooth",
    });

    // Update the theme via the editor
    thisEditor.updateTheme(className, colorName);
    if (!isMobile) {
      await delay(50); // Small delay for smooth scrolling
      updateArrowVisibility();
    }
  };

  // Define Windows-specific styles showing light colors because windows black is very black
  const setStyleText = () => {
  windowsStyles = `
  :host {
     --color-black: #222;
    --color-white: #dcdcdc;
  }

  /* Edge-specific styles */
@supports (-ms-ime-align: auto) {
  :host {
   --color-black: #7c7c7c;
    --color-white: #dbdbdb;
  }
}

/* Firefox-specific styles */
@-moz-document url-prefix() {
  :host {
   --color-black: #7c7c7c;
    --color-white: #dbdbdb;
  }
}
  `;


   windowsEdgeStyles = `
    :host {
    --color-black: #7c7c7c;
      --color-white: #dbdbdb;
    }
  `;

   textContent = `

  /* /** Slider Container */

  .page-element{
  display: flex !important;
  }

  @font-face {
  font-family: 'Lato';
  font-style: normal;
  font-weight: 400; /* Regular */
  font-display: swap;
  src: url('/dist/assets/resource/fonts/Lato-Regular.woff2') format('woff2'),
       url('/dist/assets/resource/fonts/Lato-Regular.woff') format('woff'),
       url('/dist/assets/resource/fonts/Lato-Regular.ttf') format('truetype');
}

  @font-face {
    font-family: 'Lato';
    font-style: normal;
    font-weight: 700;
    font-display: swap;
    src: url('/dist/assets/resource/fonts/Lato-700.woff2') format('woff2'),
         url('/dist/assets/resource/fonts/Lato-700.woff') format('woff');
  }

  @font-face {
    font-family: 'Open Sans';
    font-style: normal;
    font-weight: 400;
    font-stretch: normal;
    font-display: swap;
    src: url('/dist/assets/resource/fonts/OpenSans-400.woff2') format('woff2'),
         url('/dist/assets/resource/fonts/OpenSans-400.woff') format('woff');
  }

  @font-face {
    font-family: 'Open Sans';
    font-style: normal;
    font-weight: 700;
    font-stretch: normal;
    font-display: swap;
    src: url('/dist/assets/resource/fonts/OpenSans-700.woff2') format('woff2'),
         url('/dist/assets/resource/fonts/OpenSans-700.woff') format('woff');
  }

  @font-face {
    font-family: 'Oswald';
    font-style: normal;
    font-weight: 400;
    font-display: swap;
    src: url('/dist/assets/resource/fonts/Oswald-400.woff2') format('woff2'),
         url('/dist/assets/resource/fonts/Oswald-400.woff') format('woff');
  }

  @font-face {
    font-family: 'Raleway';
    font-style: normal;
    font-weight: 400;
    font-display: swap;
    src: url('/dist/assets/resource/fonts/Raleway-400.woff2') format('woff2'),
         url('/dist/assets/resource/fonts/Raleway-400.woff') format('woff');
  }

  @font-face {
    font-family: 'Roboto';
    font-style: normal;
    font-weight: 400;
    font-display: swap;
    src: url('/dist/assets/resource/fonts/Roboto-400.woff2') format('woff2'),
         url('/dist/assets/resource/fonts/Roboto-400.woff') format('woff');
  }

  @font-face {
    font-family: 'Roboto';
    font-style: normal;
    font-weight: 700;
    font-display: swap;
    src: url('/dist/assets/resource/fonts/Roboto-700.woff2') format('woff2'),
         url('/dist/assets/resource/fonts/Roboto-700.woff') format('woff');
  }

  @font-face {
    font-family: 'Rubik';
    font-style: normal;
    font-weight: 400;
    font-display: swap;
    src: url('/dist/assets/resource/fonts/Rubik-400.woff2') format('woff2'),
         url('/dist/assets/resource/fonts/Rubik-400.woff') format('woff');
  }



  @font-face {
    font-family: 'Alex Brush';
    font-style: normal;
    font-weight: 400;
    src: url('/dist/assets/resource/fonts/alexbrush-regular-webfont.woff2') format('woff2'), /* Preferred modern format */
         url('/dist/assets/resource/fonts/alexbrush-regular-webfont.woff') format('woff');   /* Fallback for older browsers */
  }


  .splide_is_active {

    border: 1px solid var( --a-color-blue) !important;
    box-shadow: 0px 0px 0rem 1px #ffffff;
  }

  .mainslider-filter-container {
    margin-bottom: 20px;
    text-align: center;
  }

  .mainslider-filter-container label {
    margin-right: 10px;
  }

  .mainslider-filter-container select {
    padding: 3px;
    font-size: 14px;
  }

  .mainslider-button-container {
    text-align: center;
    margin-bottom: 20px;
  }

  .mainslider-button-container button {
    padding: 10px 20px;
    margin: 5px;
    font-size: 16px;
    border: none;
    border-radius: 5px;
    cursor: pointer;
    background-color: #007bff;
    color: white;
    transition: background-color 0.3s;
  }

  .mainslider-button-container button:hover {
    background-color: #0056b3;
  }

  .mainslider-wrapper {
    position: relative;
    max-width: 100%;
    overflow: hidden;
    /* border: 1px solid #ddd; */
    border-radius: 0px;
    background-color: var(--slider-top);
    display: flex;
    flex-direction: column;
    height: calc(100vh - 125px);
    border-bottom-left-radius: 5px;
    border-bottom-right-radius: 5px;
  }



  .slide-topdiv{
    height: 260px;
    width: 192px;
    overflow: hidden;

  }

  .mainslider-container {
    flex-grow: 1;
    display: grid;
    gap: 25px;
    row-gap: 25px;
    grid-template-columns: repeat(auto-fit, 195px);
    grid-auto-rows: 353px;
    align-items: start;
    justify-items: start;
    background-color: var(--slider-top);
    overflow-y: auto;
    overflow-x: hidden;
    filter: brightness(var(--slider-brightness));
  }

  .mainslider-container::-webkit-scrollbar {
    display: none;
  }

  /* For Firefox */
  .mainslider-container {
    scrollbar-width: none; /* Disables the scrollbar in Firefox */
  }

  /* For Internet Explorer/Edge Legacy */
  .mainslider-container {
    -ms-overflow-style: none; /* Hides scrollbars in IE/Edge Legacy */
  }




  .mainslider-item.selected {
    border: 3px solid #007bff;
  }

  .mainslider-details {
    margin-top: 10px;
    text-align: center;
  }

  .mainslider-arrow-container {
    display: flex;
    justify-content: space-between;
    align-items: center;
    height: 28px;
    padding: 0 10px;
    border-top: 1px solid var(--resume-border);
    background-color: var(--resume-background-color);
  }

  .mainslider-arrow-container.hidden {
    display: none;
  }

  .sliderstyle-only{
    margin: 80px;
    border: 10px solid var(--resume-border);
  }

  .mainslider-container .mainslider-item {
    /* width: 182px; */
    /* height: 300px; */
    /* border: 1px solid #ddd; */
    /* border-radius: 5px; */
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    cursor: pointer;

    /* transition: border .3s; */
  }

  .mainslider-item {
    display: flex;
    align-items: center;
    justify-content: center;
    position: relative;
    border: 1px solid var(--resume-border);
  }

  .mainslider-container .mainslider-item:focus {
    outline: none;
  }

  .mainslider-container .mainslider-item:focus-visible {
    outline: none;

  }

  .mainslider-item div.content {
    transform: scale(0.14); /* Scale down the content */
    transform-origin: top left;
    width: 715%; /* Match scaling */
    height: 532%;
    position: absolute;
    top: 0;
    left: 0;
    background-color: var(--resume-background-color);
  }

  .mainslider-item.coverletter-item div.content {
    transform: scale(0.165);
    transform-origin: top left;
    width: 605%;
    height: 532%;
    position: absolute;
    top: 0;
    left: 0px;
    background-color: var(--resume-background-color);
  }




  .mainslider-container.mobile .mainslider-item:last-child {
    margin-right: 60px; /* Ensures last slide isn't cut off on mobile */
  }


  .mainslider-container.mobile {
    display: flex;
    gap: 10px;
    flex-wrap: nowrap;
    padding: 0px 10px; /* Added padding on both sides to account for scrolling space */
    overflow-x: auto;
    overflow-y: hidden;
  }


  .mainslider-filter-attributes-dropdown{
    padding: 10px;
    border-radius: 4px;
    font-size: 14px;
    margin-bottom: 10px;
    background-color: var(--slider-top);
    border: 1px solid var(--resume-border);
    color: var(--text-primary);
    -webkit-text-fill-color: var(--text-primary) !important;
    caret-color: var(--text-primary) !important;

  }

  @media (min-width: 1260px) {
    .mainslider-container .mainslider-item {
      overflow: hidden;
    }
  }

  @media (max-width: 1260px) {
    .mainslider-wrapper {
      height: 350px !important;
    }
  }

  .th_container {
    display: flex;
    flex-direction: column;
    align-items: center;
    text-align: center;
    margin-right: 0px;
    margin-left: 0px;

  }


  .bottom-of-slide {
    background-color: var(--resume-background-color);
    z-index: 2;

    padding: 0px 11px 15px 11px;
    margin-top: -25px;
  }

  .th_square-container-font {
    z-index: 6;
    display: flex;
    justify-content: space-between;

    margin-top: 0px;
    height: 40px;
    padding: 10px 7px 10px 7px;
    background-color: #fff;
    border-top: 1px solid var(--resume-border);
    margin: 0px;
  }

  .th_square-container {
    z-index: 5;
    display: flex;
    justify-content: space-between;

    margin: 0 auto;
    height: 30px;
    /* margin-top: 30px; */
    /* margin-bottom: 10px; */
    background-color: #fff;
    padding: 10px 7px 10px 7px;
  }

  .middle-text {
    z-index:2;
    display: flex;
    justify-content: center;
    align-items: center;
    padding: 2px 10px;
    font-size: 14px;
    width: 100%;
    color: var(--text-primary);
    background-color: var(--resume-background-color);
    border-top: 1px solid var(--resume-border);
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap; /* Ensures text stays in a single line */
  }


  .th_square-container2row {
    background-color: var(--resume-background-color);
    width: 172px;
  }

  .th_square-container2row.coverletter-item{
    background-color: var(--resume-background-color);
    width: 166px;
  }



  .th_square {
    width: 22px; /* Adjusted width to fit within the thumbnail */
    height: 22px; /* Adjusted height to fit within the thumbnail */
    background-color: red; /* Default background color for squares */
    margin: 0 5px; /* Adjusted margin for spacing between squares */
  }

  .th_square a {
    display: block;
    width: 100%;
    height: 100%;
    line-height: 18px;
    border: 1px solid var(--resume-border);
  }

  .th_square:hover {
    transform: scale(1.4); /* Zoom out effect on hover */
  }

  .th_active_color {
    outline: 1px solid var(--a-color-blue);
    outline-offset: 2px;
  }

   .margintablemarginscale {
      margin-left: 0px !important;
  }

  /* **/

    `;

  };




  return { init, unload, mainsliderScrollToSlide, applyFilter, updateLayout, applyClassesToVariation, variations };
})();

export default slidersetup;
